const colors = {
  primary: '#00AD94',//
  'primary-800': '#007180',
  'primary-700': '#118288',
  'primary-600': '#049595',
  'primary-500': '#1AACA4',
  'primary-300': '#24C8B0',//
  'primary-200': '#7FE8D7',
  'primary-100': '#A8F0E4',
  'primary-50': '#D1FAF0',

  secondary: '#FF6F48',
  'secondary-800': '#991A00',
  'secondary-700': '#C2350A',
  'secondary-600': '#CF3C17',
  'secondary-500': '#E85230',
  'secondary-300': '#FF8C66',
  'secondary-200': '#FFA680',
  'secondary-100': '#FFC2A3',
  'secondary-50': '#FFDFCC',

  grayLight: '#B8B8B8',
  'grayLight-1000': '#000000',
  'grayLight-990': '#1F1F1F',
  'grayLight-950': '#2B2B2B',
  'grayLight-900': '#383838',
  'grayLight-850': '#535454',
  'grayLight-800': '#525252',
  'grayLight-750': '#5b5c5c',
  'grayLight-700': '#6B6B6B',
  'grayLight-650': '#747575',
  'grayLight-600': '#818181',
  'grayLight-500': '#9A9A9A',
  'grayLight-350': '#B1B2B2',
  'grayLight-300': '#D1D1D1',
  'grayLight-200': '#DEDEDE',
  'grayLight-100': '#EBEBEB',
  'grayLight-75': '#F2F2F2',
  'grayLight-50': '#F5F7F7',
  'grayLight-40': '#eaeded',
  'grayLight-30' : '#E1E3E3',
  'grayLight-25' : '#c4c6c6',
  'grayLight-20': '#F8F8F8',
  'grayLight-10': '#F7F7F7',
  'grayLight-0': '#FFFFFF',

  grayDark: '#9DA3A8',
  'grayDark-1000': '#15171A',
  'grayDark-950': '#1C1F21',
  'grayDark-900': '#292D30',
  'grayDark-800': '#2D3438',
  'grayDark-750': '#323333',
  'grayDark-700': '#3B4145',
  'grayDark-600': '#484F54',
  'grayDark-500': '#586066',
  'grayDark-300': '#B7BEC4',
  'grayDark-200': '#CAD2D9',
  'grayDark-100': '#E2EBF2',
  'grayDark-75': '#CACCCC',
  'grayDark-50': '#DAE3EB',
  'grayDark-10': '#E5EFF7',

  success: '#2CB21D',
  'success-900': '#3C493E',
  'success-800': '#0A5907',
  'success-700': '#166B0C',
  'success-600': '#278514',
  'success-500': '#3B9F1D',
  'success-350': '#2BA53B',
  'success-300': '#38D726',
  'success-250': '#84CC16',
  'success-200': '#8DE96C',
  'success-100': '#B3ED9F',
  'success-50': '#DAF5D1',
  'success-40': '#D4EDDA',
  'success-30': '#EBFAED',

  danger: '#E16666',
  'danger-800': '#760911',
  'danger-700': '#880D16',
  'danger-600': '#9F1721',
  'danger-500': '#CD1D29',
  'danger-450': '#D94040',
  'danger-300': '#F64951',
  'danger-200': '#F86970',
  'danger-100': '#F9AFB3',
  'danger-50': '#FCD6D9',

  info: '#4099FF',
  'info-800': '#0C2A7A',
  'info-700': '#143D93',
  'info-600': '#2058B7',
  'info-550': '#2D6CF6',
  'info-500': '#2E77DB',
  'info-300': '#6FB9FF',
  'info-200': '#8CCCFF',
  'info-100': '#B2E0FF',
  'info-50': '#E0F2FE',

  alert: '#F38A3F',
  'alert-800': '#9F3D05',
  'alert-700': '#B14B03',
  'alert-600': '#D45B05',
  'alert-500': '#F56F0F',
  'alert-300': '#F9A90E',
  'alert-200': '#F5CD47',
  'alert-250': '#FBE072',
  'alert-100': '#FEE8A0',
  'alert-50': '#FEF5CF',
  'alert-20': '#FFF3CD',

  social: '#8C45AF',
  'empty-space': '#131313',
  blue: '#276EF1',
  red: '#E11900',
  green: '#048848',
  'yellow-900': '#332E24',
  'yellow-500': '#E49E15',
  'yellow-300': '#FFCF70',
  'yellow-50': '#FFFAF0',
  'red-50': '#FFEFED',
  'red-300': '#E85C4A',
  'red-200': '#F1998E',
  'red-900': '#402926',
  'blue-900': '#262F40',
  'blue-300': '#5B91F5',
  'blue-200': '#A0BFF8',
  'blue-50': '#EFF3FE',
  'green-200': '#66D19E',
  'green-500': '#03703C',
  'green-700': '#2BA53B',
  'green-900': '#24332C',
  'green-50': '#E6F2ED',
};
export default colors;
